import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ContactMe = () => {
  const formRef = useRef();
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusMsg, setStatusMsg] = useState("");

  useEffect(() => {
    if (!status) return;
    const timer = setTimeout(() => {
      setStatus(null);
      setStatusMsg("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [status]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = formRef.current;
    const honeypot = form.elements["website"]?.value;
    if (honeypot) return;

    const name = form.elements["from_name"].value.trim();
    const email = form.elements["from_email"].value.trim();
    const subject = form.elements["subject"].value.trim();
    const message = form.elements["message"].value.trim();

    if (!name || !email || !subject || !message) {
      setStatus("error");
      setStatusMsg("Please fill in all fields.");
      return;
    }

    if (!EMAIL_RE.test(email)) {
      setStatus("error");
      setStatusMsg("Please enter a valid email address.");
      return;
    }

    if (message.length < 10) {
      setStatus("error");
      setStatusMsg("Message must be at least 10 characters.");
      return;
    }

    setSending(true);
    setStatus(null);
    setStatusMsg("");

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setStatus("success");
          setStatusMsg("Message sent! I'll get back to you soon.");
          form.reset();
        },
        () => {
          setStatus("error");
          setStatusMsg("Something went wrong. Please try again.");
        }
      )
      .finally(() => setSending(false));
  };

  return (
    <section id="contact" className="contact-section">
      <Container>
        <Row>
          <Col md={12} className="contact-header">
            <h2 className="section-header">
              <span className="purple">CONTACT</span> ME
            </h2>
            <p>
              I'm always up for a good conversation — let's{" "}
              <span className="purple">connect</span>.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
              <input
                type="text"
                name="website"
                style={{ display: "none" }}
                tabIndex="-1"
                autoComplete="off"
              />

              <div className="contact-form-group">
                <label htmlFor="from_name">Name</label>
                <input
                  type="text"
                  id="from_name"
                  name="from_name"
                  className="contact-form-input"
                  placeholder="Your name"
                  required
                  minLength={2}
                  maxLength={100}
                />
              </div>

              <div className="contact-form-group">
                <label htmlFor="from_email">Email</label>
                <input
                  type="email"
                  id="from_email"
                  name="from_email"
                  className="contact-form-input"
                  placeholder="Your email"
                  required
                  maxLength={254}
                />
              </div>

              <div className="contact-form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="contact-form-input"
                  placeholder="Subject"
                  required
                  minLength={2}
                  maxLength={200}
                />
              </div>

              <div className="contact-form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  className="contact-form-textarea"
                  placeholder="Your message"
                  rows="4"
                  required
                  minLength={10}
                  maxLength={2000}
                />
              </div>

              <button
                type="submit"
                className="contact-send-btn"
                disabled={sending}
              >
                {sending ? "Sending..." : "Send Message"}
              </button>
            </form>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="social-links">
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/sriranjan-s/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/sriranjan06"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>

      {status && (
        <div
          key={statusMsg}
          className={`contact-toast ${
            status === "success" ? "contact-toast-success" : "contact-toast-error"
          }`}
        >
          {statusMsg}
        </div>
      )}
    </section>
  );
};

export default ContactMe;
